// Karşılama widget'ı — Blazor WelcomeWidget: saate göre selamlama + kullanıcı/rol bilgisi.
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '@/entities/session/model/authStore';
import { OctoMark } from '@/shared/ui/OctoMark';

export function WelcomeWidget() {
  const { t } = useTranslation();
  const user = useAuthStore((s) => s.user);
  const connectionName = useAuthStore((s) => s.connectionName);
  const hour = new Date().getHours();
  const greeting = hour < 12 ? t('home.goodMorning') : hour < 18 ? t('home.goodDay') : t('home.goodEvening');
  return (
    <div className="flex h-full items-center gap-4">
      <OctoMark className="h-12 w-12 shrink-0" />
      <div className="min-w-0">
        <h1 className="truncate text-xl font-semibold">
          {greeting}, {user?.userName}
        </h1>
        <p className="text-fg-muted truncate text-sm">
          {user?.roleName ? `${user.roleName} · ` : ''}
          {connectionName ?? t('app.name')}
        </p>
      </div>
    </div>
  );
}
